import React from 'react';
import { FileText, Download, Eye, Trash2, Lock, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CATEGORY_META, formatSize, resourceUrl, isNewResource } from './resourceLibraryApi';

export const ResourceFileRow = ({ res, token, canDelete, onDelete, onOpen }) => {
  const meta = CATEGORY_META[res.category] || {};
  const isNew = isNewResource(res);
  const open = () => onOpen?.(res);
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-l-4 ${meta.accent || ''} bg-white px-4 py-3 shadow-sm hover:shadow-md transition-shadow ${isNew ? 'ring-2 ring-amber-300/70' : ''}`}
      data-testid={`resource-row-${res.id}`}
    >
      <button type="button" onClick={open} className="flex items-start gap-3 flex-1 min-w-0 text-left group" data-testid={`resource-open-${res.id}`}>
        <div className="mt-0.5 rounded-md bg-slate-100 p-2 text-slate-600 group-hover:bg-emerald-100 group-hover:text-emerald-700 transition-colors"><FileText className="h-5 w-5" /></div>
        <div className="min-w-0">
          <p className="font-medium text-slate-900 break-words group-hover:text-emerald-700" data-testid={`resource-title-${res.id}`}>
            {isNew && <Badge className="mr-2 bg-amber-400 text-amber-950 hover:bg-amber-400 text-[10px] align-middle animate-pulse" data-testid={`resource-new-${res.id}`}><Sparkles className="h-3 w-3 mr-1" />New!</Badge>}
            {res.title}
          </p>
          {res.description && <p className="text-sm text-slate-500 line-clamp-2">{res.description}</p>}
          <p className="text-xs text-slate-400 mt-1">
            {res.file_name}{res.file_size ? ` · ${formatSize(res.file_size)}` : ''}
            {res.visibility === 'staff' && (
              <Badge variant="outline" className="ml-2 bg-rose-50 text-rose-700 border-rose-200 text-[10px]"><Lock className="h-3 w-3 mr-1" />Teachers only</Badge>
            )}
          </p>
        </div>
      </button>
      <div className="flex items-center gap-2 shrink-0">
        {onOpen ? (
          <Button size="sm" variant="outline" onClick={open} data-testid={`resource-view-${res.id}`}><Eye className="h-4 w-4 mr-1" />Open</Button>
        ) : (
          <Button asChild size="sm" variant="outline" data-testid={`resource-view-${res.id}`}>
            <a href={resourceUrl(res, token)} target="_blank" rel="noreferrer"><Eye className="h-4 w-4 mr-1" />View</a>
          </Button>
        )}
        <Button asChild size="sm" className="bg-emerald-600 hover:bg-emerald-700" data-testid={`resource-download-${res.id}`}>
          <a href={resourceUrl(res, token, true)} download={res.file_name}><Download className="h-4 w-4 mr-1" />Download</a>
        </Button>
        {canDelete && (
          <Button size="icon" variant="ghost" className="text-rose-600 hover:bg-rose-50" onClick={() => onDelete(res)} data-testid={`resource-delete-${res.id}`}>
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
